import { CSSProperties, MouseEventHandler, PropsWithChildren, useEffect, useState } from 'react';
import axios from 'axios';
import { auth } from '../../../firebase';

export interface IPrivateImageProps {
    url?: string;
    className?: string;
    style?: CSSProperties;
    onClick?: MouseEventHandler<any>;
}
export function blobToBase64(blob) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
            resolve(reader.result);
        };
    });
}

export const PrivateImage: React.FC<IPrivateImageProps & PropsWithChildren> = ({
    url,
    className,
    style,
    onClick,
    children,
}) => {
    const [image, setImage] = useState<any>('');
    useEffect(() => {
        if (!auth.currentUser) return;
        if (!url) return;
        auth.currentUser
            .getIdToken()
            .then((token) =>
                axios.get(`${url as string}&timestamp=${new Date().getTime()}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    responseType: 'blob',
                }),
            )
            .then((response) => response.data)
            .then((blob) => blobToBase64(blob))
            .then((base64) => setImage(base64));
    }, [url]);

    return (
        <div
            className={className}
            style={{
                ...style,
                backgroundImage: image ? `url('${image}')` : '',
            }}
            onClick={onClick}
        >
            {children}
        </div>
    );
};
